<template>
  <div class="teams-detail-view container py-4">
    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Bereich wird geladen...</span>
      </div>
    </div>
    
    <div v-if="error" class="alert alert-danger" role="alert">
      <font-awesome-icon icon="exclamation-triangle" /> {{ error }}
    </div>

    <TeamDetail v-else-if="selectedTeam" />

    <div v-else class="alert alert-gradient-warning" role="alert">
      <font-awesome-icon icon="exclamation-triangle" /> Bereich nicht gefunden
    </div>
  </div>

 
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useTeamsStore } from '@/stores/teams'
import TeamDetail from '@/components/teams/TeamDetail.vue'

const route = useRoute()
const router = useRouter()
const teamsStore = useTeamsStore()


const { selectedTeam, loading, error } = storeToRefs(teamsStore)


const { loadTeamById } = teamsStore

onMounted(async () => {
  const teamId = route.params.id
  if (teamId) {
    const team = await loadTeamById(teamId)
    if (!team) {
      router.push({ name: 'teams-list' })
    }
  } else {
    router.push({ name: 'teams-list' })
  }
})


watch(
  () => route.params.id,
  async (newId) => {
    if (newId && newId !== selectedTeam.value?.id) {
      const team = await loadTeamById(newId)
      if (!team) {
        router.push({ name: 'teams-list' })
      }
    }
  }
)
</script>